module.exports = __webpack_public_path__ + "img/7.496d1375.jpg";